import CustomQuerySetupWizardApiMetricBuilderStepCommonComponent from 'webapp/components/custom-query/setup/wizard/api-metric-builder/step-common';

export default class CustomQuerySetupWizardApiMetricBuilderStepDateComponent extends CustomQuerySetupWizardApiMetricBuilderStepCommonComponent {
	override stepTitle = 'Select date';
	override stepDescription =
		"Select a property holding your date (timestamp) information. If you don't get a date property, or prefer to use the current date & time for each value, select 'Use current time of storing data' below.";
	override optionNoneLabel = 'Use current time of storing data <span>(Dynamic)</span>';

	// always allow "None": discussed in https://app.asana.com/0/0/1203600470514962/1204062844384812/f
	// get isNoneDisabled(): boolean {
	// 	// disable no date option if no dimension is selected
	// 	return !this.args.form.jsonStructure?.rowDimension;
	// }

	override get noneDisabledText(): string {
		return this.isNoneDisabled ? 'Either date or dimension column is required.' : '';
	}
}
